<div class="tool-container webmate-default-theme">
  <div class="wm-topbar">
    <span class="header">Report Slot Malfunction</span>
  </div>
  <div class="introduction-text">
    <div class="info-container">
      <fa-icon [icon]="faInfoCircle"  size="lg"></fa-icon>
      Did you know that our <a href="https://docs.webmate.io/support/help/faq/" target="_blank">FAQ</a> could help you to solve a lot of common issues more quickly?
    </div>
    <div>
      <b>We are sorry to hear that you are experiencing issues with your slot.</b>
    </div>
    <br/>
    <div>
      Please describe the problem as detailed as possible and keep the device deployed if possible. We will investigate your problem immediately and contact you with additional details.
    </div>
  </div>
  @if (deviceSlot) {
    <form class="form">
      <div class="form-section">
        <div class="form-section-info">
          <h4 class="form-label">Slot</h4>
          <div class="description">The slot you wish to report to us.</div>
        </div>
        <div class="form-item-content">
          <div class="wm-devicesummary wm-m-grid-element">
            <div class="wm-m-device-right">
              <div class="wm-m-device-info-line stronger">{{deviceSlot.name}}</div>
              <div class="wm-m-device-info-line stronger">{{deviceSlot.deviceId}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-section">
        <div class="form-section-info">
          <h4 class="form-label">Report Title</h4>
          <div class="description">The title is optional.</div>
        </div>
        <div class="form-item-content">
          <input type="text" pInputText [(ngModel)]="reportTitle" name="reportTitle">
        </div>
      </div>
      <div class="form-section">
        <div class="form-section-info">
          <h4 class="form-label">Issue Description</h4>
          <div class="description">Please give us a detailed description about the issue. You can write your message in German or English.</div>
        </div>
        <div class="form-item-content">
          <textarea data-testing-id="issue-details-textarea" class="form-item-input" type="text" placeholder="Issue Details" [(ngModel)]="message" name="message" pTextarea [cols]="50" [rows]="8">
          </textarea>
        </div>
      </div>
      <button class= "submit-button" [disabled]="message.trim().length === 0 || busySendingReport" (click)="reportMalfunction()" [label]="busySendingReport ? 'Sending Report...' : 'Send Report'" pButton type="button"></button>
    </form>
  }
</div>
